<template>
    <div class="mx-2 mx-lg-5">
        <div class="card mt-3">
            <div class="card-header">
                <h3>Notifikace</h3>
            </div>
            <div class="card-body">
                <table class="table table-hover table-responsive-md text-center">
                    <thead>
                        <tr>
                            <th></th>
                            <th>{{ $t("notifications.title") }}</th>
                            <th>{{ $t("notifications.device") }}</th>
                            <th>{{ $t("notifications.created") }}</th>
                            <th>{{ $t("notifications.Status") }}</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody v-if="notifications.length">
                        <tr
                            v-for="notification in notifications"
                            :key="notification.id"
                            :class="{ 'resolved_row': notification.is_resolved }"
                            class="align-middle"
                            :style="getRowStyle(notification.level)"
                        >
                            <td></td>
                            <td>{{ notification.title }}</td>
                            <td>{{ notification.device_name }}</td>
                            <td>{{ notification.created_at ? $d(new Date(notification.created_at), 'short') : "-" }}</td>
                            <td>
                                <div class="d-flex align-items-center justify-content-center">
                                    <span
                                        :class="['status_dot', getStatusDot(notification.is_resolved)]"
                                    ></span>

                                    <span>
                                        {{ notification.is_resolved ? $t("notifications.resolved") : $t("notifications.unresolved") }}
                                    </span>
                                </div>

                                <div
                                    v-if="notification.is_resolved"
                                    class="d-flex flex-column text-muted small"
                                >
                                    <div>{{ notification.resolved_by_name }}</div>
                                    <div>{{ notification.resolved_at ? $d(new Date(notification.resolved_at), 'short') : "-" }}</div>
                                </div>
                            </td>
                            <td>
                                <button
                                    class="btn btn-primary btn-sm me-2"
                                    @click="openDetail(notification)"
                                >
                                    <icon icon="Search"></icon>
                                </button>

                                <button
                                    v-if="!notification.is_resolved"
                                    class="btn btn-success btn-sm me-2"
                                    @click="changeStatus(notification.id)"
                                    :title="$t('notifications.markAsResolved')"
                                >
                                    <icon icon="Check"></icon>
                                </button>
                                <button
                                    v-else
                                    class="btn btn-success btn-sm me-2 invisible"
                                    disabled
                                >
                                    <icon icon="Check"></icon>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                    <tbody v-else>
                        <tr>
                            <td colspan="7" class="text-center text-muted py-3">
                                {{ $t("notifications.notFound") }}
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div v-if="notifications.length >=5" class="d-flex justify-content-between mx-4">
                    <Paginate
                        :page-count="totalPages"
                        :click-handler="(p) => currentPage = p"
                        :prev-text="'«'"
                        :next-text="'»'"
                        :container-class="'pagination'"
                        :page-class="'page-item'"
                        :page-link-class="'page-link'"
                        :active-class="'active'"
                        :disabled-class="'disabled'"
                    />
                    <div class="flex-shrink-0">
                        <select v-model="perPage" class="form-select form-select-sm" style="height: 40px;">
                            <option :value="5">5</option>
                            <option :value="10">10</option>
                            <option :value="25">20</option>
                            <option :value="50">50</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <NotificationDetailModal
        ref="modalRef"
        v-show="showDetailModal"
        :notification="selectedNotification"
        @close="showDetailModal = false"
        @resolved="handleResolved"
    />
</template>

<script>
import Paginate from 'vuejs-paginate-next';
import Icon from '@/components/Icon.vue';
import NotificationDetailModal from '@/components/dashboard/notifications/NotificationDetailModal.vue';

export default {
    components: {
        Paginate,
        Icon,
        NotificationDetailModal,
    },
    data() {
        return {
            notifications: [],
            currentPage: 1,
            perPage: 10,
            showDetailModal: false,
            selectedNotification: null,
        }
    },
    created() {
        this.getNotifications();
    },
    methods: {
        getNotifications() {
            this.$store.getters.api.get(`/dashboard/${this.$route.params.slug}/notifications`)
            .then(res => {
                this.notifications = res.data;
                const count = this.notifications.filter(n => !n.is_resolved).length;
                this.$store.commit("setNotificationCount", count)
            })
            .catch(error => {
                console.error("Error loading notifications.", error);
            });
        },
        changeStatus(notificationId) {
            this.$store.getters.api.patch(`/dashboard/${this.$route.params.slug}/notifications/${notificationId}/edit`)
            .then(() => {
                this.getNotifications();

            })
            .catch(error => {
                console.error("Error updating notification status.", error);
            });
        },

        getRowStyle(level) {
            const colors = {
                critical: "rgba(220, 53, 69, 0.40)",
                error: "rgba(255, 193, 7, 0.40)",
                warning: "rgba(255, 243, 205, 0.30)",
                info: "rgba(23, 162, 184, 0.40)",
            };

            return {
                backgroundColor: colors[level] || "transparent",
            };
        },
        getStatusDot(isResolved) {
            return isResolved ? "bg-success" : "bg-danger";
        },

        openDetail(notification) {
            this.selectedNotification = notification;
            this.showDetailModal = true;

            this.$refs.modalRef.open();
        },
        handleResolved(notification) {
            this.changeStatus(notification.id);
        }
    },
    watch: {
        "$route.params.slug": {
            immediate: true,
            handler(newSlug) {
                this.getNotifications();
            }
        }
    }
}
</script>

<style scoped>
.status_dot{
    width: 18px;
    height: 18px;
    border-radius: 50%;
    margin-right: 6px;
}

.resolved_row {
  background-color: rgba(108, 117, 125, 0.1) !important;
  opacity: 0.3;
}
</style>